const loyaltyProgramStatusForSelection = ['Created', 'Active', 'Locked', 'Deleted'].map((key) => {
	return { id: key, name: key };
});

const loyaltyProgramOwnerTypeForSelection = ['ShopConfiguration'].map((key) => {
	return { id: key, name: key };
});

export { loyaltyProgramStatusForSelection };
export { loyaltyProgramOwnerTypeForSelection };
